function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { isEmpty } from 'lodash';
import { screeningsApiClient, coreApiClient, coreApi } from './config';
import { isHttpError } from '../common/utils';
import { onFetchingError } from '../common/utils/notifications';
export var findRecord = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(http, modelName, params, id) {
    var paramsSring, delimiter, modelId, url, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          paramsSring = new URLSearchParams(params).toString();
          delimiter = isEmpty(params) ? '' : '?';
          modelId = id ? "/".concat(id) : '';
          url = "/".concat(modelName).concat(modelId).concat(delimiter).concat(paramsSring);
          _context.next = 6;
          return http.get(url);
        case 6:
          response = _context.sent;
          return _context.abrupt("return", response);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function findRecord(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
export var createRecord = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(http, modelName, payload) {
    var url, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = "/".concat(modelName);
          _context2.next = 3;
          return http.post(url, payload);
        case 3:
          response = _context2.sent;
          return _context2.abrupt("return", response);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function createRecord(_x5, _x6, _x7) {
    return _ref2.apply(this, arguments);
  };
}();
export var updateRecord = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(http, modelName, id, payload) {
    var url, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          url = "/".concat(modelName, "/").concat(id);
          _context3.next = 3;
          return http.put(url, payload);
        case 3:
          response = _context3.sent;
          return _context3.abrupt("return", response);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function updateRecord(_x8, _x9, _x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}();
export var findScreenById = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(screenId, onFetchingError) {
    var screeningQuery;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return findRecord(screeningsApiClient, 'screenings', {
            "template_format": "surveyjs"
          }, screenId);
        case 3:
          screeningQuery = _context4.sent;
          if (!isHttpError(screeningQuery)) {
            _context4.next = 6;
            break;
          }
          return _context4.abrupt("return", onFetchingError(screeningQuery));
        case 6:
          return _context4.abrupt("return", screeningQuery === null || screeningQuery === void 0 ? void 0 : screeningQuery.data);
        case 9:
          _context4.prev = 9;
          _context4.t0 = _context4["catch"](0);
          onFetchingError(_context4.t0);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 9]]);
  }));
  return function findScreenById(_x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}();
export var findScreens = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(personId, offset, limit) {
    var screeningQuery, screening;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return findRecord(screeningsApiClient, 'screenings', {
            person_id: personId,
            offset: offset,
            limit: limit,
            type: 'screening'
          });
        case 3:
          screeningQuery = _context5.sent;
          screening = screeningQuery === null || screeningQuery === void 0 ? void 0 : screeningQuery.data;
          return _context5.abrupt("return", screening);
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          onFetchingError(_context5.t0);
        case 11:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 8]]);
  }));
  return function findScreens(_x14, _x15, _x16) {
    return _ref5.apply(this, arguments);
  };
}();
export var findTemplates = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(offset, limit) {
    var result, _result$data;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return findRecord(screeningsApiClient, 'templates', {
            offset: offset,
            limit: limit,
            type: 'screening'
          });
        case 2:
          result = _context6.sent;
          if (!(result.status === 200)) {
            _context6.next = 5;
            break;
          }
          return _context6.abrupt("return", result === null || result === void 0 || (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.templates);
        case 5:
          return _context6.abrupt("return", result);
        case 6:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return function findTemplates(_x17, _x18) {
    return _ref6.apply(this, arguments);
  };
}();
export var findTemplateById = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(templateId) {
    var result;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return findRecord(screeningsApiClient, 'templates', {
            "template_format": "surveyjs"
          }, templateId);
        case 2:
          result = _context7.sent;
          if (!(result.status === 200)) {
            _context7.next = 5;
            break;
          }
          return _context7.abrupt("return", result.data);
        case 5:
          return _context7.abrupt("return", result);
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return function findTemplateById(_x19) {
    return _ref7.apply(this, arguments);
  };
}();
export var fetchPreviousScreens = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(personId, templateId) {
    var result;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return findRecord(screeningsApiClient, 'screenings', {
            person_id: personId,
            template_id: templateId
          });
        case 2:
          result = _context8.sent;
          if (!(result.status === 200)) {
            _context8.next = 5;
            break;
          }
          return _context8.abrupt("return", result.data);
        case 5:
          return _context8.abrupt("return", result);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return function fetchPreviousScreens(_x20, _x21) {
    return _ref8.apply(this, arguments);
  };
}();
export var findPerson = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(subjectId) {
    var subjectResult;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return findRecord(coreApiClient, 'people', {
            subject_id: subjectId
          });
        case 2:
          subjectResult = _context9.sent;
          return _context9.abrupt("return", subjectResult);
        case 4:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return function findPerson(_x22) {
    return _ref9.apply(this, arguments);
  };
}();
export var findOrganizations = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(organizationsIds) {
    var organizations;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return coreApi.query('provider', {
            ids: organizationsIds
          });
        case 2:
          organizations = _context10.sent;
          return _context10.abrupt("return", organizations);
        case 4:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return function findOrganizations(_x23) {
    return _ref10.apply(this, arguments);
  };
}();
export var findSubjects = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(subjectsIds) {
    var subjects;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return coreApi.query('employee', {
            ids: subjectsIds
          });
        case 2:
          subjects = _context11.sent;
          return _context11.abrupt("return", subjects);
        case 4:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function findSubjects(_x24) {
    return _ref11.apply(this, arguments);
  };
}();
export var fetchInsurances = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(personId) {
    var _response$data;
    var response;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return coreApi.query('insurance', {
            person: personId,
            state: 'active'
          });
        case 2:
          response = _context12.sent;
          return _context12.abrupt("return", (response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.data) || []);
        case 4:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function fetchInsurances(_x25) {
    return _ref12.apply(this, arguments);
  };
}();
export var createScreen = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(_ref13) {
    var templateId, _ref13$status, status, personId, answers, decline_reason, source, onError, onSuccess, duration, payload, _screenResult$data, screenResult;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          templateId = _ref13.templateId, _ref13$status = _ref13.status, status = _ref13$status === void 0 ? 'draft' : _ref13$status, personId = _ref13.personId, answers = _ref13.answers, decline_reason = _ref13.decline_reason, source = _ref13.source, onError = _ref13.onError, onSuccess = _ref13.onSuccess, duration = _ref13.duration;
          payload = {
            template_id: templateId,
            status: status,
            person_id: personId,
            answers: answers,
            decline_reason: decline_reason,
            source: source,
            duration: duration
          };
          _context13.prev = 2;
          _context13.next = 5;
          return createRecord(screeningsApiClient, 'screenings', payload);
        case 5:
          screenResult = _context13.sent;
          if (!isHttpError(screenResult)) {
            _context13.next = 10;
            break;
          }
          return _context13.abrupt("return", onError());
        case 10:
          return _context13.abrupt("return", onSuccess(screenResult === null || screenResult === void 0 || (_screenResult$data = screenResult.data) === null || _screenResult$data === void 0 ? void 0 : _screenResult$data.screen));
        case 11:
          _context13.next = 16;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](2);
          onError(_context13.t0);
        case 16:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[2, 13]]);
  }));
  return function createScreen(_x26) {
    return _ref14.apply(this, arguments);
  };
}();
export var updateScreen = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(_ref15) {
    var screeningId, _ref15$status, status, answers, source, onError, onSuccess, personId, duration, payload, screenResult;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          screeningId = _ref15.screeningId, _ref15$status = _ref15.status, status = _ref15$status === void 0 ? 'draft' : _ref15$status, answers = _ref15.answers, source = _ref15.source, onError = _ref15.onError, onSuccess = _ref15.onSuccess, personId = _ref15.personId, duration = _ref15.duration;
          payload = {
            status: status,
            answers: answers,
            source: source,
            person_id: personId,
            duration: duration
          };
          _context14.prev = 2;
          _context14.next = 5;
          return updateRecord(screeningsApiClient, 'screenings', screeningId, payload);
        case 5:
          screenResult = _context14.sent;
          if (!isHttpError(screenResult)) {
            _context14.next = 10;
            break;
          }
          return _context14.abrupt("return", onError());
        case 10:
          return _context14.abrupt("return", onSuccess(screenResult === null || screenResult === void 0 ? void 0 : screenResult.data));
        case 11:
          _context14.next = 16;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](2);
          onError(_context14.t0);
        case 16:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[2, 13]]);
  }));
  return function updateScreen(_x27) {
    return _ref16.apply(this, arguments);
  };
}();
export var assignScreen = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(_ref17) {
    var submissionId, assign, response;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          submissionId = _ref17.submissionId, assign = _ref17.assign;
          _context15.next = 3;
          return screeningsApiClient.patch("screenings/".concat(submissionId, "/assign"), {
            assign: assign
          });
        case 3:
          response = _context15.sent;
          return _context15.abrupt("return", response);
        case 5:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function assignScreen(_x28) {
    return _ref18.apply(this, arguments);
  };
}();
//# sourceMappingURL=api.js.map